import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { NUMBER_OF_SWATCHES_TO_SHOW, DEFAULT_COLOR_FILTERS, DEFAULT_PRODUCTS_OBTAINED, DEFAULT_UPHOLSTERY_LABEL_FILTERS } from 'commons/constants';
import useAllProductClearanceStock from 'data-hooks/useAllProductClearanceStock';
import getLowestTierVariantFirst from './helpers/getLowestTierVariantFirst';

// This hook generates the variantsToShow property for every product in the
// products array, and returns a copy of the products array that includes this
// additional property for each product. If specified, the colorFilters array
// is used to filter product variants to only include those that match the
// specified colors.

// The colorFilters array is of the format:  ['green', 'red']
const useProductVariantsToShow = t0 => {
  const $ = _c(9);
  const {
    colorFilters: t1,
    products: t2,
    upholsteryLabelFilters: t3
  } = t0;
  const colorFilters = t1 === undefined ? DEFAULT_COLOR_FILTERS : t1;
  const products = t2 === undefined ? DEFAULT_PRODUCTS_OBTAINED : t2;
  const upholsteryLabelFilters = t3 === undefined ? DEFAULT_UPHOLSTERY_LABEL_FILTERS : t3;
  const {
    data: clearanceData
  } = useAllProductClearanceStock();
  let t4;
  if ($[0] !== clearanceData || $[1] !== colorFilters || $[2] !== products || $[3] !== upholsteryLabelFilters) {
    let t5;
    if ($[5] !== clearanceData || $[6] !== colorFilters || $[7] !== upholsteryLabelFilters) {
      t5 = (product, index) => {
        const {
          variants: t6,
          variantsTotal: t7
        } = product;
        const variants = t6 === undefined ? [] : t6;
        const variantsTotal = t7 === undefined ? 0 : t7;
        const matchingVariantsForColors = colorFilters?.length ? variants.filter(t8 => {
          const {
            color: variantColor
          } = t8;
          return colorFilters.some(color => color.includes(variantColor));
        }) : variants;
        const matchingVariantsForUpholstery = upholsteryLabelFilters?.length ? matchingVariantsForColors.filter(t9 => {
          const {
            label: variantLabel
          } = t9;
          return upholsteryLabelFilters.some(upholsteryLabel => !!upholsteryLabel && variantLabel.includes(upholsteryLabel));
        }) : matchingVariantsForColors;
        const matchingVariants = matchingVariantsForUpholstery.length ? matchingVariantsForUpholstery : matchingVariantsForColors;
        const variantsWithLowestTierFirst = getLowestTierVariantFirst(matchingVariants, product.id);
        const variantsToShow = variantsWithLowestTierFirst?.length > 0 ? variantsWithLowestTierFirst.slice(0, NUMBER_OF_SWATCHES_TO_SHOW) : variants.slice(0, NUMBER_OF_SWATCHES_TO_SHOW);
        const productClearanceData = clearanceData?.[product.id];
        const isClearance = !isEmpty(productClearanceData);
        return {
          ...product,
          isClearance,
          moreVariantsCount: variantsToShow.length ? variantsTotal - variantsToShow.length : 0,
          position: index + 1,
          variantsToShow
        };
      };
      $[5] = clearanceData;
      $[6] = colorFilters;
      $[7] = upholsteryLabelFilters;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = products.map(t5);
    $[0] = clearanceData;
    $[1] = colorFilters;
    $[2] = products;
    $[3] = upholsteryLabelFilters;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const productsWithVariantsToShow = t4;
  return productsWithVariantsToShow;
};
export default useProductVariantsToShow;